<div class="flex justify-content-center">
  <div class="grid flex">
    <div class="col-12 text-4xl text-primary text-center font-semibold">
      {{ settings.title }}
    </div>
    <div class="col-12 text-center">
      <img
        src="assets/layout/images/ami/{{ settings.addressImg }}.svg"
        width="500"
        height="250"
      />
    </div>
  </div>
</div>
